import { render, staticRenderFns } from "./Outro.vue?vue&type=template&id=c5880d3c&"
import script from "./Outro.vue?vue&type=script&lang=js&"
export * from "./Outro.vue?vue&type=script&lang=js&"
import style0 from "./Outro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports